function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Area from '../algorithm/Area';
import Geometry from './Geometry';
import Arrays from '../../../../java/util/Arrays';
import CoordinateFilter from './CoordinateFilter';
import hasInterface from '../../../../hasInterface';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import Orientation from '../algorithm/Orientation';
import System from '../../../../java/lang/System';
import GeometryComponentFilter from './GeometryComponentFilter';
import CoordinateArrays from './CoordinateArrays';
import Polygonal from './Polygonal';
import GeometryFilter from './GeometryFilter';
import CoordinateSequenceFilter from './CoordinateSequenceFilter';
var Polygon = /*#__PURE__*/function (_Geometry) {
  function Polygon() {
    var _this;
    _classCallCheck(this, Polygon);
    _this = _callSuper(this, Polygon);
    Polygon.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(Polygon, _Geometry);
  return _createClass(Polygon, [{
    key: "computeEnvelopeInternal",
    value: function computeEnvelopeInternal() {
      return this._shell.getEnvelopeInternal();
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      if (this.isEmpty()) {
        return [];
      }
      var coordinates = new Array(this.getNumPoints()).fill(null);
      var k = -1;
      var shellCoordinates = this._shell.getCoordinates();
      for (var x = 0; x < shellCoordinates.length; x++) {
        k++;
        coordinates[k] = shellCoordinates[x];
      }
      for (var i = 0; i < this._holes.length; i++) {
        var childCoordinates = this._holes[i].getCoordinates();
        for (var j = 0; j < childCoordinates.length; j++) {
          k++;
          coordinates[k] = childCoordinates[j];
        }
      }
      return coordinates;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      var area = 0.0;
      area += Area.ofRing(this._shell.getCoordinateSequence());
      for (var i = 0; i < this._holes.length; i++) {
        area -= Area.ofRing(this._holes[i].getCoordinateSequence());
      }
      return area;
    }
  }, {
    key: "isRectangle",
    value: function isRectangle() {
      if (this.getNumInteriorRing() !== 0) return false;
      if (this._shell === null) return false;
      if (this._shell.getNumPoints() !== 5) return false;
      var seq = this._shell.getCoordinateSequence();
      var env = this.getEnvelopeInternal();
      for (var i = 0; i < 5; i++) {
        var x = seq.getX(i);
        if (!(x === env.getMinX() || x === env.getMaxX())) return false;
        var y = seq.getY(i);
        if (!(y === env.getMinY() || y === env.getMaxY())) return false;
      }
      var prevX = seq.getX(0);
      var prevY = seq.getY(0);
      for (var _i = 1; _i <= 4; _i++) {
        var _x = seq.getX(_i);
        var _y = seq.getY(_i);
        var xChanged = _x !== prevX;
        var yChanged = _y !== prevY;
        if (xChanged === yChanged) return false;
        prevX = _x;
        prevY = _y;
      }
      return true;
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0];
        var tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) {
          return false;
        }
        var otherPolygon = other;
        var thisShell = this._shell;
        var otherPolygonShell = otherPolygon._shell;
        if (!thisShell.equalsExact(otherPolygonShell, tolerance)) {
          return false;
        }
        if (this._holes.length !== otherPolygon._holes.length) {
          return false;
        }
        for (var i = 0; i < this._holes.length; i++) {
          if (!this._holes[i].equalsExact(otherPolygon._holes[i], tolerance)) {
            return false;
          }
        }
        return true;
      } else return _superPropGet(Polygon, "equalsExact", this, 1).apply(this, arguments);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      if (arguments.length === 0) {
        this.normalize(this._shell, true);
        for (var i = 0; i < this._holes.length; i++) {
          this.normalize(this._holes[i], false);
        }
        Arrays.sort(this._holes);
      } else if (arguments.length === 2) {
        var ring = arguments[0];
        var clockwise = arguments[1];
        if (ring.isEmpty()) {
          return null;
        }
        var uniqueCoordinates = new Array(ring.getCoordinates().length - 1).fill(null);
        System.arraycopy(ring.getCoordinates(), 0, uniqueCoordinates, 0, uniqueCoordinates.length);
        var minCoordinate = CoordinateArrays.minCoordinate(ring.getCoordinates());
        CoordinateArrays.scroll(uniqueCoordinates, minCoordinate);
        System.arraycopy(uniqueCoordinates, 0, ring.getCoordinates(), 0, uniqueCoordinates.length);
        ring.getCoordinates()[uniqueCoordinates.length] = uniqueCoordinates[0];
        if (Orientation.isCCW(ring.getCoordinates()) === clockwise) {
          CoordinateArrays.reverse(ring.getCoordinates());
        }
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._shell.getCoordinate();
    }
  }, {
    key: "getNumInteriorRing",
    value: function getNumInteriorRing() {
      return this._holes.length;
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      return 1;
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_POLYGON;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return 2;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var len = 0.0;
      len += this._shell.getLength();
      for (var i = 0; i < this._holes.length; i++) {
        len += this._holes[i].getLength();
      }
      return len;
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      var numPoints = this._shell.getNumPoints();
      for (var i = 0; i < this._holes.length; i++) {
        numPoints += this._holes[i].getNumPoints();
      }
      return numPoints;
    }
  }, {
    key: "reverse",
    value: function reverse() {
      var poly = this.copy();
      poly._shell = this._shell.copy().reverse();
      poly._holes = new Array(this._holes.length).fill(null);
      for (var i = 0; i < this._holes.length; i++) {
        poly._holes[i] = this._holes[i].copy().reverse();
      }
      return poly;
    }
  }, {
    key: "convexHull",
    value: function convexHull() {
      return this.getExteriorRing().convexHull();
    }
  }, {
    key: "compareToSameClass",
    value: function compareToSameClass() {
      if (arguments.length === 1) {
        var o = arguments[0];
        var thisShell = this._shell;
        var otherShell = o._shell;
        return thisShell.compareToSameClass(otherShell);
      } else if (arguments.length === 2) {
        var _o = arguments[0];
        var comp = arguments[1];
        var poly = _o;
        var _thisShell = this._shell;
        var _otherShell = poly._shell;
        var shellComp = _thisShell.compareToSameClass(_otherShell, comp);
        if (shellComp !== 0) return shellComp;
        var nHole1 = this.getNumInteriorRing();
        var nHole2 = poly.getNumInteriorRing();
        var i = 0;
        while (i < nHole1 && i < nHole2) {
          var thisHole = this.getInteriorRingN(i);
          var otherHole = poly.getInteriorRingN(i);
          var holeComp = thisHole.compareToSameClass(otherHole, comp);
          if (holeComp !== 0) return holeComp;
          i++;
        }
        if (i < nHole1) return 1;
        if (i < nHole2) return -1;
        return 0;
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      if (hasInterface(arguments[0], CoordinateFilter)) {
        var filter = arguments[0];
        this._shell.apply(filter);
        for (var i = 0; i < this._holes.length; i++) {
          this._holes[i].apply(filter);
        }
      } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
        var _filter = arguments[0];
        this._shell.apply(_filter);
        if (!_filter.isDone()) {
          for (var _i2 = 0; _i2 < this._holes.length; _i2++) {
            this._holes[_i2].apply(_filter);
            if (_filter.isDone()) break;
          }
        }
        if (_filter.isGeometryChanged()) this.geometryChanged();
      } else if (hasInterface(arguments[0], GeometryFilter)) {
        var _filter2 = arguments[0];
        _filter2.filter(this);
      } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
        var _filter3 = arguments[0];
        _filter3.filter(this);
        this._shell.apply(_filter3);
        for (var _i3 = 0; _i3 < this._holes.length; _i3++) {
          this._holes[_i3].apply(_filter3);
        }
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      if (this.isEmpty()) {
        return this.getFactory().createMultiLineString();
      }
      var rings = new Array(this._holes.length + 1).fill(null);
      rings[0] = this._shell;
      for (var i = 0; i < this._holes.length; i++) {
        rings[i + 1] = this._holes[i];
      }
      if (rings.length <= 1) return this.getFactory().createLinearRing(rings[0].getCoordinateSequence());
      return this.getFactory().createMultiLineString(rings);
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_POLYGON;
    }
  }, {
    key: "copy",
    value: function copy() {
      var shellCopy = this._shell.copy();
      var holeCopies = new Array(this._holes.length).fill(null);
      for (var i = 0; i < this._holes.length; i++) {
        holeCopies[i] = this._holes[i].copy();
      }
      return new Polygon(shellCopy, holeCopies, this._factory);
    }
  }, {
    key: "getExteriorRing",
    value: function getExteriorRing() {
      return this._shell;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._shell.isEmpty();
    }
  }, {
    key: "getInteriorRingN",
    value: function getInteriorRingN(n) {
      return this._holes[n];
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Polygon;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Polygonal];
    }
  }]);
}(Geometry);
export { Polygon as default };
Polygon.constructor_ = function () {
  this._shell = null;
  this._holes = null;
  var shell = arguments[0];
  var holes = arguments[1];
  var factory = arguments[2];
  Geometry.constructor_.call(this, factory);
  if (shell === null) {
    shell = this.getFactory().createLinearRing();
  }
  if (holes === null) {
    holes = [];
  }
  if (Geometry.hasNullElements(holes)) {
    throw new IllegalArgumentException('holes must not contain null elements');
  }
  if (shell.isEmpty() && Geometry.hasNonEmptyElements(holes)) {
    throw new IllegalArgumentException('shell is empty but holes are not');
  }
  this._shell = shell;
  this._holes = holes;
};
Polygon.serialVersionUID = -3494792200821764533;